import AdminOrdersList from "./AdminOrdersList";

function PrincipalDashboard() {
  return (
    <div>
      <AdminOrdersList />
    </div>
  );
}

export default PrincipalDashboard;
